const COACH_SETTINGS_FIELD_MAPPINGS = [
  { settingsKey: "name", propertyKey: "name" },
  { settingsKey: "surname", propertyKey: "surname" },
  { settingsKey: "exercise_unit", propertyKey: "exerciseUnit" },
  { settingsKey: "rir_or_rpe", propertyKey: "rirOrRpe" },
  { settingsKey: "coach_language", propertyKey: "coachLanguage" },
  {
    settingsKey: "show_athlete_exercise_stats",
    propertyKey: "showAthleteExerciseStats",
    defaultValue: false,
  },
  {
    settingsKey: "show_set_priority",
    propertyKey: "showSetPriority",
    defaultValue: true,
  },
  {
    settingsKey: "default_block_view",
    propertyKey: "defaultBlockView",
    defaultValue: "workouts-string",
  },
  {
    settingsKey: "default_show_nutrition_plan_totals",
    propertyKey: "defaultShowNutritionPlanTotals",
    defaultValue: true,
  },
];

const isValidCoach = (coach) => !!coach && typeof coach === "object";

const resolveComparableValue = (value, defaultValue) =>
  value === undefined || value === null ? defaultValue : value;

export const getCoachSettingsPersistedComparableValues = (coach) => {
  if (!isValidCoach(coach)) {
    return {};
  }

  return COACH_SETTINGS_FIELD_MAPPINGS.reduce((accumulator, mapping) => {
    accumulator[mapping.settingsKey] = resolveComparableValue(
      coach[mapping.propertyKey],
      mapping.defaultValue
    );
    return accumulator;
  }, {});
};

export const getChangedCoachSettingKeys = (coach) => {
  if (!isValidCoach(coach)) {
    return [];
  }

  const settings = coach.coachSettings ?? {};
  const persistedValues = getCoachSettingsPersistedComparableValues(coach);

  return COACH_SETTINGS_FIELD_MAPPINGS.filter(
    ({ settingsKey }) => settings[settingsKey] !== persistedValues[settingsKey]
  ).map(({ settingsKey }) => settingsKey);
};

export const hasCoachSettingsUnsavedChanges = (coach) =>
  getChangedCoachSettingKeys(coach).length > 0;

export const syncCoachSettingsDraftWithPersistedData = (coach) => {
  if (!isValidCoach(coach)) {
    return;
  }

  const persistedValues = getCoachSettingsPersistedComparableValues(coach);

  COACH_SETTINGS_FIELD_MAPPINGS.forEach(({ settingsKey }) => {
    if (typeof coach.setSettings === "function") {
      coach.setSettings(settingsKey, persistedValues[settingsKey]);
      return;
    }

    if (!coach.coachSettings || typeof coach.coachSettings !== "object") {
      coach.coachSettings = {};
    }

    coach.coachSettings[settingsKey] = persistedValues[settingsKey];
  });
};

export const discardCoachSettingsDraft = (coach) => {
  syncCoachSettingsDraftWithPersistedData(coach);
};

export { COACH_SETTINGS_FIELD_MAPPINGS };
